import Head from "next/head";
import { fromUrl, toUrl } from "common/src/Aperture.bs";
// import { make as TeamCompositionsPage } from "../../src/team-comps/TeamCompositions2Page.bs";
import { make as TeamCompositionsPage } from "../../src/tc2/Tc2Page.bs";
import { getApertures } from "../../utils/static-paths";
import { renderFull, toApiUrl as patchToUrl } from "common/src/Patch.bs";

export default function Comps({ aperture, initialData, initialKey }) {
  return (
    <>
      <Head>
        <title>{`TFT Meta Stats - Best Team Comps & Builds for Set 15 Patch ${renderFull(
          aperture.patch,
        )}`}</title>
      </Head>
      <TeamCompositionsPage initialData={initialData} initialKey={initialKey} />
    </>
  );
}

export async function getStaticPaths() {
  const params = getApertures();
  return {
    // paths: params.map((params) => ({
    //   params: params,
    // })),
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, locale }) {
  const aperture = fromUrl(params.slug || []);
  let key = "team-compositions";
  if (aperture.queue == 1130) {
    key = "hr-team-compositions";
  } else if (aperture.queue === 1160) {
    key = "duo-team-compositions";
  } else if (aperture.queue === 6110) {
    // key = "doh-team-compositions";
    key = "rr-team-compositions";
  } else if (aperture.queue === 6100) {
    // key = "fates-team-compositions";
    // key = "76-team-compositions";
    key = "revival-team-compositions";
  } else if (aperture.queue === 6000) {
    key = "galaxy-team-compositions";
  }
  const resp = await fetch(
    `https://api.tft.tools/${key}/${aperture.rankGroup}/${patchToUrl(
      aperture.patch,
    )}`,
  );

  const initialData = await resp.json();

  initialData.groups = initialData.groups.filter(
    (g) => g.full.count / initialData.count >= 0.05 / 8,
  );
  initialData.groups.sort((g1, g2) => g1.full.place - g2.full.place);
  initialData.groups = initialData.groups.slice(0, 5);

  return {
    props: {
      aperture: aperture,
      initialKey: toUrl(aperture),
      initialData,
    },
    revalidate: 3600,
  };
}
